import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DetailsHistorieStatus, VerlaufEintrag } from '../../models/details-historie.model';
import { AvatarComponent } from '../avatar/avatar.component';
import { DetailsHistorieStatusComponent } from '../details-historie-card/details-historie-status/details-historie-status.component';

@Component({
  selector: 'app-verlauf-liste',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, TranslatePipe, AvatarComponent, DetailsHistorieStatusComponent],
  templateUrl: './verlauf-liste.component.html',
  styleUrl: './verlauf-liste.component.scss',
})
export class VerlaufListeComponent {
  readonly eintraege = input<VerlaufEintrag[]>([]);
  readonly status = input<DetailsHistorieStatus>('bereit');
  readonly fehlerText = input<string | null>(null);
  readonly leerText = input<string | null>(null);
  readonly retry = output<void>();

  protected readonly zeitMuster = 'dd.MM.yyyy · HH:mm';

  protected istLeer(text: string | null | undefined): boolean {
    return !text?.trim();
  }
}
